import {
  IMatchReportsHome,
  IMatchMenu,
} from "@sky-it-livedata/livedata-sports-design-system";
import { isValidMatchReportsHome } from "./typeguards";
import {
  CreateCompetitionReportsInputSchema,
  CompetitionReportsList,
} from "appsync";
import { WidgetError, ErrorName } from "../../../utils/errors";
import { MatchReportsQuery } from "../types";
import {
  IGliderPayload,
  getGlider,
  ICompetition,
} from "../../../utils/glider";

type AndataRitornoTouple = [
  CompetitionReportsList,
  CompetitionReportsList | undefined,
];
type GroupedReportsType = Record<string, AndataRitornoTouple>;

export default (obj: MatchReportsQuery): IMatchReportsHome => {

  if (isValidMatchReportsHome(obj)) {
    CreateCompetitionReportsInputSchema().parse(
      obj.data.getCompetitionReports,
      { reportInput: true }
    );

    const { competitionId, seasonId, reports } = obj.data.getCompetitionReports;

    const gliderPayload: IGliderPayload = {
      competitionId,
      seasonId,
      currentRound: reports?.[0]?.round || 0,
      matchRoundList: reports
        ?.sort((a, b) => (a?.round ?? 0) - (b?.round ?? 0))
        .map((report) => ({
          ...report,
          round: report?.round ?? 0,
          status: "past",
        })) as ICompetition[],
    };

    const glider: IMatchMenu = getGlider(gliderPayload, null);
    const { gliderItems } = glider;

    const linearReports: CompetitionReportsList[] =
      reports?.filter(
        (report): report is CompetitionReportsList =>
          !!report && !report.competitionPhase
      ) ?? [];
    const nonLinearReports: CompetitionReportsList[] =
      reports?.filter(
        (report): report is CompetitionReportsList =>
          !!report && !!report.competitionPhase
      ) ?? [];

    const groupedNonLiearReports: GroupedReportsType = nonLinearReports.reduce(
      (grouped, report: CompetitionReportsList) => {
        const phase = report.competitionPhase!;
        grouped[phase] = [...(grouped[phase] || []), report];
        return grouped;
      },
      {} as { [key: string]: any }
    );

    const mergedNonLinearReports: CompetitionReportsList[] =
      Object.values<AndataRitornoTouple>(groupedNonLiearReports).map(
        ([andata, ritorno]) => {
          if (!ritorno) {
            return andata;
          }

          return {
            ...ritorno,
            matchList: [
              ...(andata.matchList || []),
              ...(ritorno.matchList || []),
            ],
          };
        }
      );

    const matchDayList: CompetitionReportsList[] = [
      ...linearReports,
      ...mergedNonLinearReports,
    ].sort((a, b) => (b?.round ?? 0) - (a?.round ?? 0));

    return {
      gliderItems,
      matchDayList,
    } as IMatchReportsHome;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in MatchReportsQuery object",
      data: obj,
    });
  }
};
